import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";

import { RanaContextMenu } from "@nens/ranalib";

import { usePublicationStore } from "../../../store/store";
import type { Layer } from "../../../types/publication";
import { useStudyAreaActions } from "../hooks/use-study-area-actions";

type StudyAreaHeaderActionsProps = {
  layer: Layer;
  onRemoveStudyArea: () => void;
};

export function StudyAreaHeaderActions({ layer, onRemoveStudyArea }: StudyAreaHeaderActionsProps) {
  const toggleStudyAreaVisibilityForCurrentMap = usePublicationStore(
    (state) => state.toggleStudyAreaVisibilityForCurrentMap
  );

  const actions = useStudyAreaActions(layer, onRemoveStudyArea);

  return (
    <>
      {layer.visible ? (
        <ViewIcon
          color="brand.sky"
          opacity={0.25}
          _groupHover={{ opacity: 1 }}
          boxSize={4}
          cursor="pointer"
          onClick={toggleStudyAreaVisibilityForCurrentMap}
        />
      ) : (
        <ViewOffIcon
          color="brand.sky"
          boxSize={4}
          cursor="pointer"
          onClick={toggleStudyAreaVisibilityForCurrentMap}
        />
      )}
      <Box opacity={0} _groupHover={{ opacity: 1 }}>
        <RanaContextMenu actions={actions} />
      </Box>
    </>
  );
}
